import debounce from 'debounce'
// import removeChildren from '@utilities/remove-children'

const search = () => {
  const searchInput = document.querySelector('.form__search')
  const categories = document.querySelectorAll('.programme__description')
  const searchHasFound = 'search--has-found'

  /* Fetch motions filtered by comparing value from
     input field with credits; template: search.php */
  const motionFetch = async (value) => {

    /* POST method requires data as FormData */
    const formData = new FormData()
    formData.append('value', value)

    /* Config data for Fetch request. Given headers are
       permitted by Kirby */
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }

    const res = await fetch(`/search`, config)

    if (res.status !== 200) throw Error("Something is wrong! No results!")

    return await res.json()
  }

  searchInput.addEventListener('input', debounce(async () => {
    const value = searchInput.value
    const countElement = document.querySelector('.search__count')
    let count = 0

    if (value.length >= 3) {
      const resultsContainer = document.querySelector('.search__results-body')
      const data = await motionFetch(value)
      const dataCategories = []

      resultsContainer.innerHTML = "";

      data.forEach(item => dataCategories.push(item.category))

      for (let category of categories) {
        const parent = category.parentElement
        const time = parent.getAttribute('data-time')
        const startTime = parent.getAttribute('data-start')
        const endTime = new Date(new Date(`2019/01/01 ${startTime}`).getTime() + (15 * 60000)).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', hour12: false })
        const dataLocation = parent.getAttribute('data-location')
        let categoryText = category.innerText
        let location = ""

        switch (dataLocation) {
          case "platforms_participants":
            location = "Platforms"
            break;
          case "passages_participants":
            location = "Tunnels"
            break;
          case "front_participants":
            location = "Central Hall"
            break;
          case "back_participants":
            location = "IJ Hall"
            break;
          default:
            location = "Central Hall"
        }

        if (categoryText.includes('Takeover')) categoryText = "Takeover all screens"

        if (dataCategories.indexOf(category.innerText) !== -1) {
          const html = `
            <tr class="search__results-row" role="button" data-start="${startTime}" data-time="${time}" data-location="${dataLocation}" js-hook-motion>
              <td>${startTime} - ${endTime}</td>
              <td class="search__results-category">${categoryText}</td>
              <td>${location}</td>
            </tr>`

          count++
          parent.classList.add(searchHasFound)
          resultsContainer.insertAdjacentHTML('beforeend', html)
        } else {
          parent.classList.remove(searchHasFound)
        }
      }

      countElement.innerText = `${count} search result${count > 1 || count === 0 ? "s" : ""}`

    } else {
      const activeCategories = document.querySelectorAll(`.${searchHasFound}`)
      document.querySelector('.search__results-body').innerHTML = "";
      countElement.innerText = "⠀"

      activeCategories.forEach(element => element.classList.remove(searchHasFound))
    }
  }, 150))
}

export default search


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/javascript/components/search.js